/** Foto, ricette e fogli di lei (DEC-23). Solo il ruolo `individuo` li vede. */
import { api } from './client'

export type TipoDocumento = 'ricetta_cucina' | 'foglio' | 'foto' | 'altro'

export type Documento = {
  id: string
  kind: TipoDocumento
  title: string | null
  media_type: string
  size_bytes: number
  read_status: 'da_leggere' | 'letto' | 'non_letto'
  created_at: string
  read_at: string | null
  read_text?: string | null
}

export const documentiApi = {
  list: () => api.get<{ documents: Documento[] }>('/documents'),
  get: (id: string) => api.get<{ document: Documento }>(`/documents/${id}`),
  file: (id: string) => api.get<{ media_type: string; data_b64: string }>(`/documents/${id}/file`),
  create: (body: { kind: TipoDocumento; media_type: string; data_b64: string }) =>
    api.post<{ document: Documento }>('/documents', body),
  read: (id: string) => api.post<{ document: Documento }>(`/documents/${id}/read`),
  remove: (id: string) => api.del<{ deleted: boolean }>(`/documents/${id}`),
}

/**
 * La foto del telefono (anche HEIC su iPhone: il browser la decodifica) diventa un JPEG di al
 * massimo 1600 px: abbastanza per leggere una ricetta, leggera da mandare.
 */
export async function preparaFoto(file: File, lato = 1600): Promise<{ media_type: string; data_b64: string }> {
  const url = URL.createObjectURL(file)
  try {
    const img = await new Promise<HTMLImageElement>((ok, ko) => {
      const el = new Image()
      el.onload = () => ok(el)
      el.onerror = () => ko(new Error('foto non leggibile'))
      el.src = url
    })
    const scala = Math.min(1, lato / Math.max(img.naturalWidth, img.naturalHeight))
    const canvas = document.createElement('canvas')
    canvas.width = Math.round(img.naturalWidth * scala)
    canvas.height = Math.round(img.naturalHeight * scala)
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('canvas non disponibile')
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
    const dataUrl = canvas.toDataURL('image/jpeg', 0.85)
    return { media_type: 'image/jpeg', data_b64: dataUrl.slice(dataUrl.indexOf(',') + 1) }
  } finally {
    URL.revokeObjectURL(url)
  }
}
